module.exports = __webpack_public_path__ + "img/winter_oak.059baf63.jpg";